'use strict';

exports.__esModule = true;
exports.default = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _twig = require('twig');

var _twig2 = _interopRequireDefault(_twig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactTwig = function (_React$Component) {
  _inherits(ReactTwig, _React$Component);

  function ReactTwig() {
    _classCallCheck(this, ReactTwig);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  ReactTwig.prototype.compileTemplate = function compileTemplate(template, data) {
    return _twig2.default.twig({ data: template }).render(data);
  };

  ReactTwig.prototype.render = function render() {
    var _props = this.props,
        template = _props.template,
        data = _props.data,
        Component = _props.Component;


    if (!template) {
      return false;
    }

    var __html = this.compileTemplate(template, data);

    return _react2.default.createElement(Component, { dangerouslySetInnerHTML: { __html: __html } });
  };

  return ReactTwig;
}(_react2.default.Component);

exports.default = ReactTwig;


ReactTwig.defaultProps = {
  data: {},
  Component: 'div'
};

ReactTwig.propTypes = process.env.NODE_ENV !== "production" ? {
  Component: _propTypes2.default.string.isRequired,
  template: _propTypes2.default.string.isRequired,
  data: _propTypes2.default.object
} : {};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-twig/lib/index.js
// module id = 112
// module chunks = 0